export default __webpack_public_path__ + "static/media/location.93d7c870.svg";